export default [
  {
    path: '/app/fairs',
    name: 'Fairs',
    component: () => import('@/views/Admin/Fairs/Index.vue'),
    meta: {
      pageTitle: 'Fuarlar',
      breadcrumb: [
        {
          text: 'Liste',
          active: true,
        },
      ],
      resource: 'ADMIN_FAIRS_LIST',
      action: 'read',
    },
  },
  {
    path: '/app/fairs/add',
    name: 'FairsAdd',
    component: () => import('@/views/Admin/Fairs/Add.vue'),
    meta: {
      pageTitle: 'Fuarlar',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/fairs',
          active: false,
        },
        {
          text: 'Oluştur',
          active: true,
        },
      ],
      resource: 'ADMIN_FAIRS_ADD',
      action: 'read',
    },
  },
  {
    path: '/app/fairs/edit/:id',
    name: 'FairsEdit',
    component: () => import('@/views/Admin/Fairs/Edit.vue'),
    meta: {
      pageTitle: 'Fuarlar',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/fairs',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
      resource: 'ADMIN_FAIRS_EDIT',
      action: 'read',
    },
  },
]
